import { render } from "./HospitalAccModal.vue?vue&type=template&id=97721fb2&scoped=true"
import script from "./HospitalAccModal.vue?vue&type=script&lang=js"
export * from "./HospitalAccModal.vue?vue&type=script&lang=js"

import "./HospitalAccModal.vue?vue&type=style&index=0&id=97721fb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97721fb2"]])

export default __exports__